import React from 'react';
import styled from 'styled-components';
import { Icon as SemanticIcon } from 'semantic-ui-react';
import { usePageTranslations } from 'hooks/usePageTranslations';

const HistoryButton = ({ onClick, disabled = false }) => {
  const t = usePageTranslations('ProtoType/CopilotV2/Components/HistoryButton/translations');
  
  return (
    <StyledHistoryButton
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      <SemanticIcon name="history" />
      {t('history')}
    </StyledHistoryButton>
  );
};

export default HistoryButton;

const StyledHistoryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  color: #111827;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-family: "Raleway";
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;
  
  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f9fafb;
    color: #9ca3af;
    
    &:hover {
      background: #f9fafb;
      border-color: #e5e7eb;
    }
  }
`;

